var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosedEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.49999C13.76 4.49999 16 6.73999 16 9.49999C16 10.01 15.9 10.5 15.76 10.96L18.82 14.02C20.21 12.79 21.31 11.25 22 9.48999C20.27 5.10999 16 1.99999 11 1.99999C9.73 1.99999 8.51 2.19999 7.36 2.56999L9.53 4.73999C10 4.59999 10.49 4.49999 11 4.49999ZM1.71 1.15999C1.32 1.54999 1.32 2.17999 1.71 2.56999L3.68 4.53999C2.06 5.82999 0.77 7.52999 0 9.49999C1.73 13.89 6 17 11 17C12.52 17 13.97 16.7 15.31 16.18L18.03 18.9C18.42 19.29 19.05 19.29 19.44 18.9C19.83 18.51 19.83 17.88 19.44 17.49L3.13 1.15999C2.74 0.769993 2.1 0.769993 1.71 1.15999ZM11 14.5C8.24 14.5 6 12.26 6 9.49999C6 8.72999 6.18 7.99999 6.49 7.35999L8.06 8.92999C8.03 9.10999 8 9.29999 8 9.49999C8 11.16 9.34 12.5 11 12.5C11.2 12.5 11.38 12.47 11.57 12.43L13.14 14C12.49 14.32 11.77 14.5 11 14.5ZM13.97 9.16999C13.82 7.76999 12.72 6.67999 11.33 6.52999L13.97 9.16999Z",
    fill: "#C6CAC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/closedEye.7754b4092bebbc17114634b4e3343198.svg";
export { ForwardRef as ReactComponent };